import { useState, useEffect, useMemo } from 'react';
import { PM_PROVIDERS } from 'common/constants/constants';
import {
  getTableColumnsByProviderName,
  getTableDataByProviderName
} from './entities-table.service';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { getEntitiesCounterMapperByKey } from 'components/FilterMenus/FilterMenus.service';

const usePmEntitiesTable = ({
  pmToolConfig,
  entityName,
  entities = [],
  filteredEntities = [],
  selectedEntities
}) => {
  const [allSelected, setAllSelected] = useState(null);
  const { getSettingOrDefinitionValue } = useSettingsService();
  const ignorePmMetaDataEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.ignorePmMetaDataEnabled
  });

  const shouldPaginate = entities?.length > 100;

  const isAzureBoardsProjects =
    pmToolConfig.sensor_id === PM_PROVIDERS.AZURE_BOARDS &&
    entityName === pmToolConfig.entity_names.project;

  const isEntitiesFiltered = entities.length !== filteredEntities.length;
  const isSelectAllEnabled = isAzureBoardsProjects && !isEntitiesFiltered;

  const cols = useMemo(() =>
    getTableColumnsByProviderName(
      pmToolConfig.name,
      ignorePmMetaDataEnabled,
      entityName,
      isSelectAllEnabled && setAllSelected,
      allSelected
    )
  );

  const rows = useMemo(() => {
    const mapEntitiesCountByName =
      filteredEntities.length < 1000
        ? getEntitiesCounterMapperByKey(filteredEntities, 'name')
        : {};

    const rowsWithSelection = filteredEntities.map(entity => {
      const shouldShowEntitiyId =
        mapEntitiesCountByName[entity?.name?.toLowerCase()] > 1;

      const entityWithSelection = {
        ...entity,
        ...(shouldShowEntitiyId && {
          name: `${entity.name} (ID: ${entity.provider_id})`
        }),
        isSelected: selectedEntities.isEntitySelected(entity.provider_id),
        toggleSelection: () => selectedEntities.toggleEntity(entity)
      };
      return getTableDataByProviderName(pmToolConfig.name)(
        entityWithSelection,
        entityName
      );
    });
    return rowsWithSelection;
  }, [filteredEntities]);

  useEffect(() => {
    const entitiesUsedBy = entities.filter(
      entity => entity.usedByTeams?.length || entity.usedByProjects?.length
    );
    selectedEntities.setValues(allSelected ? entities : entitiesUsedBy);
  }, [allSelected]);

  return {
    cols,
    rows,
    shouldPaginate
  };
};

export default usePmEntitiesTable;
